import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import { walkArray } from "@/utils/commonUtil";
import { QuestionType } from "@/modules/newCommunity/pages/operationTools/config/newQuestionnaire";
export const randomFormRules = {
  randomSet: [{
    required: true,
    message: "请设置随机范围"
  }],
  randomRange: [{
    required: true,
    message: "请设置随机范围"
  }],
  num: [{
    required: true,
    message: "请输入题目数量"
  }, {
    pattern: /(^[1-9][0-9]{0,5}$)/,
    message: "请输入1~999999范围内的整数",
    trigger: "blur"
  }],
  selectClassification: [{
    required: true,
    message: "请选择分类"
  }],
  randomProps: [{
    required: true,
    message: "请设置题数",
    trigger: "change"
  }, {
    validator: (rule, value, callback) => {
      value.forEach(item => {
        if (!item.num || item.num > item.relationNum || !/(^[1-9][0-9]{0,5}$)/.test(item.num)) {
          callback(new Error("请填写不大于分类总题数的随机抽取的题数"));
          return;
        }
      });
      callback();
    },
    trigger: "change"
  }]
};
export const getRandomForm = () => {
  return {
    randomSet: false,
    randomRange: "all",
    selectClassification: [],
    num: null,
    randomProps: []
  };
};
export const convertData = itemList => {
  const dataList = [];
  walkArray(itemList, item => {
    const question = {
      componentName: item.type,
      data: {
        qbid: item.qbid,
        id: "",
        required: item.required,
        number: item.number,
        type: item.componentName,
        style: item.componentType,
        fromQuestionBank: true,
        title: item.question
      },
      // checked: false,
      fromQuestionBank: true
    };
    if (item.type == QuestionType.singleChoice) {
      const optionsList = item.optionsList.map(op => {
        return {
          ...op,
          id: "",
          jsonConfig: op.jsonConfig ? JSON.parse(op.jsonConfig) : {
            exclusive: false
          }
        };
      });
      question.data = {
        ...question.data,
        optionsList: optionsList,
        optionContentType: item.optionContentType,
        scoreRule: item.scoreRule,
        itemScore: item.itemScore || 0,
        title: item.question,
        jsonConfig: item.jsonConfig ? JSON.parse(item.jsonConfig) : {
          subTitle: "",
          showIndex: true,
          otherInputForm: "NONE",
          otherInputNumberMin: undefined,
          otherInputNumberMax: undefined,
          otherInputNumberPrecision: 0,
          otherInputMin: undefined,
          otherInputMax: undefined,
          openPoint: false
        }
      };
    }
    if (item.type == QuestionType.multipleChoice) {
      const optionsList = item.optionsList.map(op => {
        return {
          ...op,
          id: "",
          jsonConfig: op.jsonConfig ? JSON.parse(op.jsonConfig) : {
            exclusive: false
          }
        };
      });
      question.data = {
        ...question.data,
        optionsList: optionsList,
        optionContentType: item.optionContentType,
        itemScore: item.itemScore,
        title: item.question,
        scoreRule: item.scoreRule,
        jsonConfig: item.jsonConfig ? JSON.parse(item.jsonConfig) : {
          subTitle: "",
          showIndex: true,
          otherInputForm: "NONE",
          otherInputNumberMin: undefined,
          otherInputNumberMax: undefined,
          otherInputNumberPrecision: 0,
          otherInputMin: undefined,
          otherInputMax: undefined,
          selectRangeMin: "",
          selectRangeMax: ""
        }
      };
    }
    if (item.type == QuestionType.uploadAddon) {
      question.data = {
        ...question.data,
        itemScore: item.itemScore,
        uploadLimitCount: item.uploadLimitCount,
        title: item.question,
        jsonConfig: item.jsonConfig ? JSON.parse(item.jsonConfig) : {
          subTitle: "",
          picTypes: [".png", ".jpg", ".jpeg"],
          fileTypes: [],
          showIndex: true,
          isIndeterminateFile: false,
          isIndeterminatePic: false
        }
      };
    }
    if (item.type == QuestionType.fillIn) {
      const jsonConfig = item.jsonConfig ? JSON.parse(item.jsonConfig) : {
        default: ""
      };
      question.data = {
        ...question.data,
        itemScore: item.itemScore,
        // content: item.content,
        content: jsonConfig.default,
        scoreRule: item.scoreRule,
        title: item.question,
        jsonConfig: jsonConfig
      };
    }
    dataList.push(question);
  });
  return dataList;
};